/* Microsoft Clarity events for the gift funnel and product views (WO-779, V42 proposal, Oct 20, 2026).
   The theme sent NO Clarity events before this file: the Clarity app embed (config/settings_data.json) only records sessions, and the
   dashboard's Smart events count clicks and URLs on whatever the dashboard rules match. This file names the steps in code so a funnel can
   be built from them:
     product_viewed   once per page view of any product template (body class template-product, which every product.*.json template has)
     gift_started     the first time the customer taps the gift card's open control or ticks the plain gift checkbox (product page, cart drawer,
                      cart page); changes made by the gift scripts themselves are not counted
     gift_saved       the first confirmed save of a gift (the gift sync code announces mezgift:saved once the cart answer holds Gift = yes)
     begin_checkout   the first click on a checkout button, a checkout link or a dynamic checkout button (Shop Pay and the other wallets)
   Tags, for filtering a funnel: gift = yes after a saved gift, gift_surface = product, drawer or cart.
   Read only: nothing here writes to the cart or wraps a request; gift_saved is announced by the gift sync code after its own confirmed save.
   Checkout itself (Shopify's checkout pages) does not load the theme or app embeds, so the last step this file can see is begin_checkout;
   purchases are read from Shopify orders (Gift attribute yes), not from Clarity.
   Switch: Theme settings > Tracking > Send Microsoft Clarity events (data-enabled on the script tag). */
(function () {
  var tag = document.currentScript;
  if (tag && tag.getAttribute('data-enabled') === 'false') return;
  if (window.__mzClarityEvents) return;
  window.__mzClarityEvents = true;

  // Clarity's loader keeps a queue until it has loaded, so calling before that is safe
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  function send(name) { try { window.clarity('event', name); } catch (e) { /* tracking never breaks the page */ } }
  function set(key, value) { try { window.clarity('set', key, value); } catch (e) { /* same */ } }
  var done = {};
  function once(name) { if (done[name]) return false; done[name] = true; send(name); return true; }

  var body = document.body || document.documentElement;
  function surfaceOf(el) {
    if (el && el.closest && el.closest('cart-drawer')) return 'drawer';
    if (body.classList.contains('template-cart')) return 'cart';
    return 'product';
  }

  // product_viewed: once per page view, on every product template
  function viewed() { if (document.body.classList.contains('template-product')) once('product_viewed'); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', viewed); else viewed();

  // gift_started: the customer's own start. Either a tap on the gift card's open control (data-gp-act="open", the product page, drawer and cart
  // page card), or the customer ticking the plain gift checkbox (a trusted change). Changes the gift scripts make themselves (restoring a saved gift,
  // following another copy of the card, the quiet switch-on during Save) are never trusted events and are not counted.
  function started(el) { if (once('gift_started')) set('gift_surface', surfaceOf(el)); }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (e.isTrusted && t && t.closest) { var open = t.closest('[data-gp-act="open"]'); if (open) started(open); }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (e.isTrusted && t && t.matches && t.matches('[data-gift-toggle]') && t.checked) started(t);
  }, true);

  // gift_saved: sent by the gift sync code itself (snippets/mezuzah-gift-sync.liquid) only after the cart's answer held the values it sent and
  // that write is still the current one; nothing here reads a response
  document.addEventListener('mezgift:saved', function () { if (once('gift_saved')) set('gift', 'yes'); });

  // begin_checkout: the same buttons and links the gift script treats as a way out of the cart
  var EXIT = 'a[href*="/checkout"], [name="checkout"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart, shopify-buy-it-now-button, shop-pay-wallet-button';
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest(EXIT)) once('begin_checkout'); }, true);
})();
